import { Button } from "@material-ui/core"
import { useHistory } from "react-router-dom"
import KeyboardReturnIcon from '@material-ui/icons/KeyboardReturn'
export const ButtonReturn = () => {
    const history = useHistory()
    const handleClick = () => {
        history.goBack()
        return null
    }
    return (
        <Button
            variant="contained"
            onClick={handleClick}
            style={{ display: "flex", justifyContent: "center", alignItems: "center", gap: "15px" }}
        >
            <KeyboardReturnIcon />
            Regresar
        </Button>
    )
}
export default ButtonReturn